import { createAction, props } from '@ngrx/store';
import { RegistrationResult } from '@qvs/core';

export const initiateRegistration = createAction(
  '[Registration] Initiate Registration',
  props<{ contractnumber: string; initialPassphrase: string }>()
);

export const initiateRegistrationSuccess = createAction(
  '[Registration] Initiate Registration Success',
  props<{ registration: RegistrationResult }>()
);

export const initiateRegistrationFailure = createAction(
  '[Registration] Initiate Registration Failure',
  props<{ registrationResult: RegistrationResult; error: boolean }>()
);

export const registrationAccepted = createAction('[Registration] Registration Accepted');

export const cancelRegistration = createAction('[Registration] Cancel Registration');

export const registrationRejected = createAction(
  '[Registration] Registration Rejected',
  props<{ registrationResult: RegistrationResult; error: boolean }>()
);

export const resetRegistration = createAction('[Registration] Reset Registration');
